import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import { NavigationItem } from 'modules/experience-core';

import { ALL_NAVIGATION_ITEMS } from '../constants';

export const useActiveNavigation = () => {
  const history = useHistory();

  const [activeNavigation, setActiveNavigation] = useState<NavigationItem>();

  useEffect(() => {
    if (activeNavigation) {
      return;
    }
    const currentActiveNavigationItem = ALL_NAVIGATION_ITEMS.find(item =>
      history.location.pathname.includes(item.link),
    );
    setActiveNavigation(currentActiveNavigationItem);
  }, [activeNavigation, history.location.pathname]);

  return {
    activeNavigation,
    setActiveNavigation,
  };
};
